import { Component, OnInit, ViewChild, ElementRef, EventEmitter, Output } from '@angular/core';
import { ApiService } from '../../api.service'
import { Router, ActivatedRoute} from '@angular/router';
import { Proflie } from '../../../profile';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-photography-dashboard',
  templateUrl: './photography-dashboard.component.html',
  styleUrls: ['./photography-dashboard.component.scss']
})
export class PhotographyDashboardComponent implements OnInit {

  isUserLogin: boolean;
  photography: Proflie[];
  item: Proflie[];
  id: any;
  url: any;
  public errorMsg: any;
  seachItemList: Object;
  faSearch = faSearch;
  searchForm: FormGroup;
  searchControl = new FormControl();
  filteredOptions: Observable<string[]>;
  autoCompleteList: Object;
  total: any;

  @ViewChild('autocompleteInput') autocompleteInput: ElementRef;
  @Output() onSelectedOption = new EventEmitter();

  constructor(private userApi: ApiService,
    private router:Router,
    private route: ActivatedRoute,
    private fb: FormBuilder) {       
      const newLocal = this.isUserLogin = this.userApi.isLoggedIn();
    }

  ngOnInit(): void {

    this.userApi.getPhotos('all',null).subscribe(
      data => {
      this.photography = data;
      this.userApi.postsData = data;
      // console.log(this.photography);
      this.total = Object.keys(data).length;
      },
      error => this.errorMsg = error    
    );

    // when user types something in input, the value changes will come through this
    this.searchControl.valueChanges.subscribe(userInput => {
      this.autoCompleteExpenseList(userInput);
    });

    this.searchForm = this.fb.group({
      search: ['', Validators.required]
    }); 

  }

  onSelect(item: any) {
    this.router.navigate(['../../../photography', item.url, {type: item.item_category, postType: 'photography'}]); // Absolute url
    // this.router.navigate([item.url, {type: item.item_category}], {relativeTo: this.route}); // relative url
  }

  addNewItem() {
    this.router.navigate(['/user/dashboard/photography/add', {type:'photography'}]);
  }

  editItem(item: any){
    this.id = item.id;
    this.url = item.url;
    this.router.navigate(['/user/dashboard/photography/edit/'+ this.id, {id:this.id,type:'photography',url:this.url}]);
  }

  deleteItem(item: Proflie): void{
    this.userApi.deleteItem(item)
      .subscribe(data => {
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.onSameUrlNavigation = 'reload';
        this.router.navigate(['/user/dashboard/photography']);
      })
  }

  private autoCompleteExpenseList(input: any) {
    this.seachItemList = this.filterSeachItems(input)
    this.autoCompleteList = this.seachItemList;
    this.total = Object.keys(this.autoCompleteList).length;
  }
  
  // this is where filtering the data happens according to you typed value
  filterSeachItems(val: any) {
    var seachItemList = []
    if (typeof val != "string") {
      return [];
    }
    if (val === '' || val === null) {
      return this.photography;
    }
    return val ? this.photography.filter(s => s.title.toLowerCase().indexOf(val.toLowerCase()) != -1)
      : this.photography;
  }

}